import {
  input,
  validations
} from "@/components/Tools/FormHelperFactory/Configurations/baseConfigurations";

export const number = {
  ...input,
  ...validations
};
